// Hook half of the api config seam. Reads the Context defined in
// ./context.ts. Split from config.tsx (the Provider) so each file
// keeps a single concern and the react-refresh lint rule is happy.
import { useContext } from "react";
import {
  InrangeAgentsApiConfigContext,
  type InrangeAgentsApiConfig,
} from "./context";

export const useInrangeAgentsApiConfig = (): InrangeAgentsApiConfig => {
  const ctx = useContext(InrangeAgentsApiConfigContext);
  if (!ctx) {
    throw new Error(
      "useInrangeAgentsApiConfig must be used inside InrangeAgentsApiConfigProvider",
    );
  }
  return ctx;
};
